import { IDeleteControlePatrimonioControleUseCase } from "../../../presentation/useCases/delete/delete_controle_patrimonio_controle_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * DeleteControlePatrimonioControleUseCase
 */

export class DeleteControlePatrimonioControleUseCase implements IDeleteControlePatrimonioControleUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async deleteControlePatrimonioControle(
    idControleCentroCusto: number,
  ): Promise<void> {
    await this.repository.deleteControlePatrimonioControle(
      idControleCentroCusto,
    );
  }
}
